import { defineStore } from "pinia";
import api from "@/modules/api";
import { MediaUploadFileItem } from "@/types/component";
import { showFailToast } from "vant";
import i18n from "@/locales";
import { Media, MediaType } from "@/types/entity";
import { useGlobalUser } from "./globalUser";
import { useDebounceFn } from "@vueuse/core";

const debouncedRefreshStorageSize = useDebounceFn(() => {
  useGlobalUser().refresh();
}, 500);

export const useMedia = defineStore("media", {
  state: () => {
    return {};
  },
  actions: {
    async uploadMedia(
      file: MediaUploadFileItem | MediaUploadFileItem[],
      mateId: number,
      mediaType: MediaType
    ) {
      if (file instanceof Array) {
        const promises = file.map((item) =>
          this.uploadMediaItem(item, mateId, mediaType)
        );
        return Promise.all(promises);
      } else {
        return [await this.uploadMediaItem(file, mateId, mediaType)];
      }
    },
    async uploadMediaItem(
      file: MediaUploadFileItem,
      mateId: number,
      mediaType: MediaType
    ): Promise<MediaUploadFileItem> {
      file.status = "uploading";
      try {
        let res: Media = (await api.uploadMedia(mediaType, file.file!, mateId))
          .item;
        file.status = "done";
        file.url = res.url;
        file.mediaId = res.id!;
        file.videoCoverUrl = res.videoCoverUrl ?? "";
        file.isNsfw = res.isNsfw;
        file.media = res;
        debouncedRefreshStorageSize();
        return file;
      } catch (e) {
        file.status = "failed";
        throw e;
      }
    },
    /** 校验上传是否完成，若存在上传中或上传失败的文件返回false并展示toast */
    validateMediaListElseToast(
      emptyListCheck = false,
      ...multiMediaList: MediaUploadFileItem[][]
    ) {
      return multiMediaList.every((mediaList) => {
        if (mediaList.length === 0) {
          return !emptyListCheck;
        }
        return mediaList.every((media) => {
          if (media.status === "uploading") {
            showFailToast(i18n.global.t("Message.someMoreContentUpload"));
            return false;
          } else if (media.status === "failed" || !media.mediaId) {
            showFailToast(i18n.global.t("Message.someContentUploadFailed"));
            return false;
          } else {
            return true;
          }
        });
      });
    },
    async deleteMateMedia(mediaId: number) {
      return api.deleteMateMedia(mediaId);
    },
    async deleteModuleMedia(mediaId: number) {
      return api.deleteOneModuleMedia(mediaId);
    },
    async updateMateMedia(
      id: number,
      params: { name: ""; visibility: VisibilityStatus; price: number }
    ) {
      return api.updateMateMedia(id, params);
    },
  },
});
